var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.form
        ? _c(
            "div",
            [
              _vm._t("top"),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _vm.id && (!_vm.readonly && !_vm.compare)
                      ? _c("q-btn", {
                          attrs: {
                            outline: "",
                            color: "negative",
                            label: "delete record",
                            icon: "delete"
                          },
                          on: { click: _vm.handleDeleteRecord }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c("div", { staticClass: "col-6 text-right" }, [
                  _vm.id
                    ? _c("div", { staticClass: "q-subheading" }, [
                        _c("strong", [_vm._v("ID:")]),
                        _vm._v(
                          "\n            " + _vm._s(_vm.id) + "\n          "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _c("div", { staticClass: "block q-pa-sm" }),
              _vm.editingDisabled
                ? _c(
                    "q-alert",
                    {
                      staticClass: "q-mb-md",
                      attrs: { type: "warning", icon: "warning" }
                    },
                    [
                      _vm._v(
                        "This record has been deleted / archived. You may not make edits to this record until it has been restore."
                      )
                    ]
                  )
                : _vm._e(),
              _vm._l(Object.keys(_vm.sections), function(sectionKey) {
                return !_vm.show(sectionKey)
                  ? _c(
                      "div",
                      { key: sectionKey, staticClass: "block full-width" },
                      [
                        _c("div", { staticClass: "row justify-between" }, [
                          _c("div", { staticClass: "col-md-10" }, [
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "text-grey-6 uppercase no-margin q-headline q-pb-sm",
                                attrs: { id: _vm.cleanId(sectionKey) }
                              },
                              [_vm._v(_vm._s(sectionKey))]
                            )
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-md-2 text-right" },
                            [
                              Object.keys(_vm.sections).length > 1 &&
                              !_vm.isModal
                                ? _c(
                                    "q-btn-dropdown",
                                    {
                                      staticClass: "self-center no-shadow",
                                      attrs: {
                                        label: "Scroll To",
                                        color: "primary",
                                        size: "sm"
                                      }
                                    },
                                    [
                                      _c(
                                        "q-list",
                                        { attrs: { link: "" } },
                                        _vm._l(
                                          Object.keys(_vm.sections),
                                          function(sectionKey) {
                                            return _c(
                                              "q-item",
                                              {
                                                key: sectionKey,
                                                nativeOn: {
                                                  click: function($event) {
                                                    _vm.handleScroll(
                                                      _vm.cleanId(sectionKey)
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "q-item-main",
                                                  [
                                                    _c(
                                                      "q-item-tile",
                                                      { attrs: { label: "" } },
                                                      [
                                                        _vm._v(
                                                          _vm._s(sectionKey)
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "mdi-card full-width q-pa-md" },
                          [
                            _c(
                              "div",
                              { staticClass: "row" },
                              _vm._l(_vm.sections[sectionKey], function(
                                column
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: column.field,
                                    class: [
                                      !column.repeat &&
                                      !column.relation &&
                                      column.component.is !== "q-editor"
                                        ? [
                                            "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                                          ]
                                        : "col-12",
                                      _vm.showHide(column) ? "hidden" : ""
                                    ]
                                  },
                                  [
                                    column.formDisplay !== false
                                      ? _vm._t(
                                          column.field + "__field",
                                          function() {
                                            return [
                                              _c(
                                                "q-field",
                                                {
                                                  class: [
                                                    _vm.showHide(column)
                                                      ? "invisible"
                                                      : "",
                                                    "q-pa-md",
                                                    _vm.requiredFields[
                                                      column.name
                                                    ]
                                                      ? "is-required"
                                                      : ""
                                                  ],
                                                  attrs: {
                                                    orientation: "vertical",
                                                    label: column.label,
                                                    "icon-color": _vm.errors.has(
                                                      column.name,
                                                      _vm.validatorFormName
                                                    )
                                                      ? "negative"
                                                      : _vm.requiredFields[
                                                          column.name
                                                        ]
                                                      ? _vm.fieldColor
                                                      : _vm.inputBgColor,
                                                    helper: column.description,
                                                    icon: _vm._f("fieldIcon")(
                                                      column,
                                                      _vm.errors,
                                                      _vm.validatorFormName
                                                    ),
                                                    error: _vm.errors.has(
                                                      column.name,
                                                      _vm.validatorFormName
                                                    ),
                                                    "error-label": _vm.errors.first(
                                                      column.name,
                                                      _vm.validatorFormName
                                                    ),
                                                    warning: _vm.compareForms(
                                                      _vm.form,
                                                      column
                                                    ),
                                                    inset: "full",
                                                    id: column.name
                                                  }
                                                },
                                                [
                                                  _c(
                                                    column.component.is,
                                                    _vm._b(
                                                      {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value:
                                                              column.component
                                                                .validation,
                                                            expression:
                                                              "column.component.validation"
                                                          }
                                                        ],
                                                        ref:
                                                          "formCol_" +
                                                          column.name,
                                                        refInFor: true,
                                                        tag: "component",
                                                        staticClass:
                                                          "no-shadow",
                                                        attrs: {
                                                          "validator-form-name":
                                                            _vm.validatorFormName,
                                                          "data-vv-scope":
                                                            _vm.validatorFormName,
                                                          "data-vv-name":
                                                            column.field,
                                                          "hide-underline": "",
                                                          color:
                                                            column.component
                                                              .props &&
                                                            column.component
                                                              .props.color
                                                              ? column.component
                                                                  .props.color
                                                              : _vm.inputBgColor,
                                                          "inverted-light": "",
                                                          value: _vm._f(
                                                            "columnDefaultValue"
                                                          )(_vm.form, column),
                                                          "model-id": _vm.id,
                                                          "parent-id": _vm.id
                                                            ? _vm.id
                                                            : _vm.savedId,
                                                          column: column,
                                                          resource:
                                                            _vm.resource,
                                                          disabled: _vm._f(
                                                            "disabledColumn"
                                                          )(column)
                                                        },
                                                        on: {
                                                          add: _vm.handleAdd,
                                                          remove: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleRemove(
                                                              column.field,
                                                              $event
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleInput(
                                                              column.field,
                                                              $event
                                                            )
                                                          },
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleInput(
                                                              column.field,
                                                              $event
                                                            )
                                                          },
                                                          "manual-update":
                                                            _vm.updateFormField,
                                                          "async-init":
                                                            _vm.handleAsyncInit,
                                                          "async-complete":
                                                            _vm.handleAsyncComplete,
                                                          sync: function(
                                                            $event
                                                          ) {
                                                            return _vm.syncRelation(
                                                              column
                                                            )
                                                          }
                                                        }
                                                      },
                                                      "component",
                                                      column.component.props,
                                                      false
                                                    )
                                                  ),
                                                  _vm.compare &&
                                                  _vm.compareId &&
                                                  _vm.compareForms(
                                                    _vm.form,
                                                    column
                                                  )
                                                    ? _c(
                                                        "q-card",
                                                        {
                                                          staticClass:
                                                            "q-mt-md",
                                                          attrs: {
                                                            color: "grey-1",
                                                            "text-color":
                                                              "black"
                                                          }
                                                        },
                                                        [
                                                          _c("q-card-title", [
                                                            _c(
                                                              "span",
                                                              {
                                                                attrs: {
                                                                  slot:
                                                                    "subtitle"
                                                                },
                                                                slot: "subtitle"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Previous " +
                                                                    _vm._s(
                                                                      column.label
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ]),
                                                          _c(
                                                            "q-card-separator"
                                                          ),
                                                          _c(
                                                            "q-card-main",
                                                            [
                                                              _c(
                                                                column.component
                                                                  .is,
                                                                _vm._b(
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "validate",
                                                                        rawName:
                                                                          "v-validate",
                                                                        value:
                                                                          column
                                                                            .component
                                                                            .validation,
                                                                        expression:
                                                                          "column.component.validation"
                                                                      }
                                                                    ],
                                                                    ref:
                                                                      "formCol_" +
                                                                      column.name,
                                                                    refInFor: true,
                                                                    tag:
                                                                      "component",
                                                                    staticClass:
                                                                      "no-shadow",
                                                                    attrs: {
                                                                      "validator-form-name":
                                                                        _vm.validatorFormName,
                                                                      "data-vv-scope":
                                                                        _vm.validatorFormName,
                                                                      "data-vv-name":
                                                                        column.field,
                                                                      "hide-underline":
                                                                        "",
                                                                      color:
                                                                        column
                                                                          .component
                                                                          .props &&
                                                                        column
                                                                          .component
                                                                          .props
                                                                          .color
                                                                          ? column
                                                                              .component
                                                                              .props
                                                                              .color
                                                                          : _vm.inputBgColor,
                                                                      "inverted-light":
                                                                        "",
                                                                      value: _vm._f(
                                                                        "columnDefaultValue"
                                                                      )(
                                                                        _vm.compareModel,
                                                                        column
                                                                      ),
                                                                      "model-id":
                                                                        _vm.id,
                                                                      "parent-id": _vm.id
                                                                        ? _vm.id
                                                                        : _vm.savedId,
                                                                      column: column,
                                                                      resource:
                                                                        _vm.resource,
                                                                      disabled: _vm._f(
                                                                        "disabledColumn"
                                                                      )(column),
                                                                      compare:
                                                                        _vm.compare,
                                                                      "compare-id": _vm.getCompareModelId(
                                                                        _vm.form,
                                                                        column
                                                                      ),
                                                                      "add-button": false,
                                                                      "show-search": false,
                                                                      "show-browse": false
                                                                    },
                                                                    on: {
                                                                      add:
                                                                        _vm.handleAdd,
                                                                      remove: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleRemove(
                                                                          column.field,
                                                                          $event
                                                                        )
                                                                      },
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleInput(
                                                                          column.field,
                                                                          $event
                                                                        )
                                                                      },
                                                                      change: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleInput(
                                                                          column.field,
                                                                          $event
                                                                        )
                                                                      },
                                                                      "manual-update":
                                                                        _vm.updateFormField,
                                                                      "async-init":
                                                                        _vm.handleAsyncInit,
                                                                      "async-complete":
                                                                        _vm.handleAsyncComplete,
                                                                      sync: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.syncRelation(
                                                                          column
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  "component",
                                                                  column
                                                                    .component
                                                                    .props,
                                                                  false
                                                                )
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ]
                                          },
                                          {
                                            column: column,
                                            modelId: _vm.id,
                                            resource: _vm.resource,
                                            value: _vm.form[column.field] || "",
                                            config: _vm.config
                                          }
                                        )
                                      : _vm._e(),
                                    _vm._t(column.field + "__after", null, {
                                      column: column,
                                      modelId: _vm.id,
                                      resource: _vm.resource,
                                      value: _vm.form[column.field] || "",
                                      config: _vm.config
                                    })
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              }),
              _vm.invalidFields.length
                ? _c(
                    "div",
                    { staticClass: "q-pa-md" },
                    [
                      _c("q-alert", {
                        attrs: {
                          type: "info",
                          message: "Form Invalid",
                          detail:
                            "You have " +
                            _vm.invalidFields.length +
                            " fields invalid"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._t("bottom"),
              _vm.editingDisabled
                ? _c(
                    "div",
                    [
                      _vm.editingDisabled
                        ? _c(
                            "q-alert",
                            {
                              staticClass: "q-mb-md",
                              attrs: { type: "warning", icon: "warning" }
                            },
                            [
                              _vm._v(
                                "This record has been deleted / archived. You may not make edits to this record until it has been restore."
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "q-btn",
                        {
                          staticClass: "full-width",
                          attrs: {
                            color: "negative",
                            push: "",
                            size: "lg",
                            disabled: false
                          },
                          on: { click: _vm.apiRestoreRecord }
                        },
                        [_vm._v("Restore")]
                      )
                    ],
                    1
                  )
                : !_vm.readonly && (_vm.compare || _vm.pendingApproval)
                ? _c(
                    "div",
                    [
                      _c(
                        "q-btn-dropdown",
                        {
                          staticClass: "full-width",
                          attrs: {
                            color: "primary",
                            label: "Actions",
                            push: "",
                            size: "lg"
                          }
                        },
                        [
                          _c(
                            "q-list",
                            { attrs: { link: "" } },
                            [
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.handleApiSync(false)
                                    }
                                  }
                                },
                                [
                                  _c("q-item-side", {
                                    attrs: {
                                      icon: "save",
                                      inverted: "",
                                      color: "primary"
                                    }
                                  }),
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [_vm._v("Save")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.handleApproveSave(true)
                                    }
                                  }
                                },
                                [
                                  _c("q-item-side", {
                                    attrs: {
                                      icon: "check_box",
                                      inverted: "",
                                      color: "green"
                                    }
                                  }),
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [_vm._v("Save and Approve")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : !_vm.readonly && !_vm.compare
                ? _c("div", [
                    _vm.isModal &&
                    _vm.parentResourceColumn &&
                    _vm.parentResourceColumn.relation &&
                    _vm.parentResourceColumn.relation.requiresParentSave
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-6 q-pr-md" },
                            [
                              _c(
                                "q-btn",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    color: "secondary",
                                    push: "",
                                    size: "lg",
                                    disabled: false
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleApiSync(false)
                                    }
                                  }
                                },
                                [_vm._v("Save and Close")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-sm-6 a-pl-md" },
                            [
                              _c(
                                "q-btn",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    color: "primary",
                                    push: "",
                                    size: "lg",
                                    disabled: false
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleApiSync(true)
                                    }
                                  }
                                },
                                [_vm._v("Save and Stay")]
                              )
                            ],
                            1
                          )
                        ])
                      : _c(
                          "div",
                          [
                            _c(
                              "q-btn",
                              {
                                staticClass: "full-width",
                                attrs: {
                                  color: "primary",
                                  push: "",
                                  size: "lg",
                                  disabled: false
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleApiSync(false)
                                  }
                                }
                              },
                              [_vm._v("Save")]
                            )
                          ],
                          1
                        )
                  ])
                : _vm._e(),
              !_vm.compare && !_vm.pendingApproval
                ? _vm._t(
                    "goback",
                    function() {
                      return [
                        _c(
                          "q-btn",
                          {
                            directives: [
                              {
                                name: "go-back",
                                rawName: "v-go-back",
                                value: _vm.listUrl,
                                expression: "listUrl"
                              }
                            ],
                            staticClass: "q-mt-lg",
                            attrs: { flat: "", color: "negative", full: "" }
                          },
                          [_vm._v("Cancel")]
                        )
                      ]
                    },
                    null,
                    _vm.listUrl
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _c(
        "q-modal",
        {
          attrs: {
            minimized: "",
            "no-esc-dismiss": "",
            "no-backdrop-dismiss": ""
          },
          model: {
            value: _vm.saveModalOpen,
            callback: function($$v) {
              _vm.saveModalOpen = $$v
            },
            expression: "saveModalOpen"
          }
        },
        [
          _c("q-modal-layout", [
            _c("div", { staticClass: "modal-header" }, [
              _vm._v("Save Complete")
            ]),
            _c(
              "div",
              { staticClass: "modal-body modal-message modal-scroll" },
              [
                _c("p", [
                  _vm._v(
                    "Your record has been successfully saved. What do you want to do next?"
                  )
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "modal-buttons row" },
              [
                _c("q-btn", {
                  staticClass: "no-shadow",
                  attrs: { color: "indigo-9", label: "Add New", outline: "" },
                  on: { click: _vm.goToAdd }
                }),
                _c("q-btn", {
                  staticClass: "no-shadow",
                  attrs: { color: "secondary", label: "Stay", outline: "" },
                  on: { click: _vm.goToEdit }
                }),
                _c("q-btn", {
                  staticClass: "no-shadow",
                  attrs: {
                    color: "primary",
                    label: "Return to List",
                    outline: ""
                  },
                  on: { click: _vm.goToList }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            minimized: "",
            "no-esc-dismiss": "",
            "no-backdrop-dismiss": ""
          },
          model: {
            value: _vm.deleteModalOpen,
            callback: function($$v) {
              _vm.deleteModalOpen = $$v
            },
            expression: "deleteModalOpen"
          }
        },
        [
          _c("q-modal-layout", [
            _c("div", { staticClass: "modal-header" }, [
              _vm._v("Delete Complete")
            ]),
            _c(
              "div",
              { staticClass: "modal-body modal-message modal-scroll" },
              [
                _c("p", [
                  _vm._v(
                    "Your record has been successfully deleted. What do you want to do next?"
                  )
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "modal-buttons row" },
              [
                _c("q-btn", {
                  staticClass: "no-shadow",
                  attrs: { color: "indigo-9", label: "Add New", outline: "" },
                  on: { click: _vm.goToAdd }
                }),
                _vm.isModal
                  ? _c("q-btn", {
                      staticClass: "no-shadow",
                      attrs: { color: "secondary", label: "Stay", outline: "" },
                      on: {
                        click: function($event) {
                          _vm.deleteModalOpen = false
                        }
                      }
                    })
                  : _vm._e(),
                _c("q-btn", {
                  staticClass: "no-shadow",
                  attrs: {
                    color: "primary",
                    label: "Return to List",
                    outline: ""
                  },
                  on: { click: _vm.goToList }
                }),
                _c("q-btn", {
                  staticClass: "no-shadow",
                  attrs: {
                    color: "black",
                    label: "Previous Page",
                    outline: ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.go(-1)
                    }
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("q-inner-loading", {
        attrs: {
          visible: _vm.waitingForSave || !!_vm.asyncInProgress || !_vm.loaded
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }